const actionTypes = {
    ROUTE_UPDATE: "ROUTE_UPDATE",
    GET_FULLSCREEN: "GET_FULLSCREEN",
    CHANGE_SLIDE: "CHANGE_SLIDE",
    FORCE_SLIDE: "FORCE_SLIDE",

    GET_CLUBS: "GET_CLUBS",
    MAKE_CLUB_LIST: "MAKE_CLUB_LIST",
    CLUBS_SUCCESS: "CLUBS_SUCCESS",
    CLUBS_FAILURE: "CLUBS_FAILURE",

    TOGGLE_LEAGUE_MENU: "TOGGLE_LEAGUE_MENU",

    CURRENT_CLUB_REQUEST: "CURRENT_CLUB_REQUEST",
    CURRENT_CLUB_SUCCESS: "CURRENT_CLUB_SUCCESS",
    RESET_CURRENT_CLUB: "RESET_CURRENT_CLUB",

    CURRENT_CLUB_MEMBERS_REQUEST: "CURRENT_CLUB_MEMBERS_REQUEST",
    CURRENT_CLUB_MEMBERS_SUCCESS: "CURRENT_CLUB_MEMBERS_SUCCESS",

    DISBAND_CLUB_REQUEST: "DISBAND_CLUB_REQUEST",
    DISBAND_CLUB_SUCCESS: "DISBAND_CLUB_SUCCESS",
    DISBAND_CLUB_FAILURE: "DISBAND_CLUB_FAILURE",

    GLOBALACCOUNT_SUCCESS: "GLOBALACCOUNT_SUCCESS",
    GLOBALACCOUNT_FAILURE: "GLOBALACCOUNT_FAILURE",
    GLOBAL_UPDATE_SUCCESS: "GLOBAL_UPDATE_SUCCESS",
    GLOBAL_UPDATE_FAILURE: "GLOBAL_UPDATE_FAILURE",

    CURRENT_CLUB: "CURRENT_CLUB",
    CURRENT_SUCCESS: "CURRENT_SUCCESS",
    CURRENT_FAILURE: "CURRENT_FAILURE",
    CURRENT_UPDATE: "CURRENT_UPDATE",
    CURRENT_BALANCE_SUCCESS: "CURRENT_BALANCE_SUCCESS",
    CURRENT_BALANCE_FAILURE: "CURRENT_BALANCE_FAILURE",

    REQUEST_TABLES: "REQUEST_TABLES",
    GET_TABLES: "GET_TABLES",
    TABLES_SUCCESS: "TABLES_SUCCESS",
    TABLES_FAILURE: "TABLES_FAILURE",

    GAMES_REQUEST: 'GAMES_REQUEST',
    GAMES_SUCCESS: 'GAMES_SUCCESS',
    GAMES_FAIL: 'GAMES_FAIL',
    BETTING_GAMES_SUCCESS: 'BETTING_GAMES_SUCCESS',
    BETTING_GAMES_FAIL: 'BETTING_GAMES_FAIL',
    LIVECASINO_GAMES_SUCCESS: 'LIVECASINO_GAMES_SUCCESS',
    LIVECASINO_GAMES_FAIL: 'LIVECASINO_GAMES_FAIL',
    PROVIDERS_REQUEST: 'PROVIDERS_REQUEST',
    PROVIDERS_SUCCESS: 'PROVIDERS_SUCCESS',
    GAME_TAGS_SUCCESS: 'GAME_TAGS_SUCCESS',
    PROVIDERS_FAIL: 'PROVIDERS_FAIL',
    PRODUCTS_TYPES_REQUEST: 'PRODUCTS_TYPES_REQUEST',
    PRODUCTS_TYPES_SUCCESS: 'PRODUCTS_TYPES_SUCCESS',
    PRODUCTS_TYPES_FAIL: 'PRODUCTS_TYPES_FAIL',
    GAME_CATEGORIES_REQUEST: 'GAME_CATEGORIES_REQUEST',
    GAME_CATEGORIES_SUCCESS: 'GAME_CATEGORIES_SUCCESS',
    GAME_CATEGORIES_FAIL: 'GAME_CATEGORIES_FAIL',
    SET_GAME_CATEGORY: 'SET_GAME_CATEGORY',
    SET_GAME_CATEGORIES: 'SET_GAME_CATEGORIES',
    TOURNAMENTS_REQUEST: 'TOURNAMENTS_REQUEST',
    TOURNAMENTS_SUCCESS: 'TOURNAMENTS_SUCCESS',
    TOURNAMENTS_FAIL: 'TOURNAMENTS_FAIL',
    SET_TOURNAMENT: 'SET_TOURNAMENT',
    SELECT_TOURNAMENT: 'SELECT_TOURNAMENT',

    TOURNAMENT_CASINO_REGISTER_REQUEST: 'TOURNAMENT_CASINO_REGISTER_REQUEST',
    TOURNAMENT_CASINO_REGISTER_SUCCESS: 'TOURNAMENT_CASINO_REGISTER_SUCCESS',
    TOURNAMENT_CASINO_UNREGISTER_SUCCESS: 'TOURNAMENT_CASINO_UNREGISTER_SUCCESS',
    TOURNAMENT_CASINO_REGISTER_SUCCESS_RESET: 'TOURNAMENT_CASINO_REGISTER_SUCCESS_RESET',
    TOURNAMENT_CASINO_REGISTER_FAIL: 'TOURNAMENT_CASINO_REGISTER_FAIL',
    TOURNAMENT_CASINO_UNREGISTER_REQUEST: 'TOURNAMENT_CASINO_UNREGISTER_REQUEST',
    TOURNAMENT_CASINO_UNREGISTER_SUCCESS_RESET: 'TOURNAMENT_CASINO_UNREGISTER_SUCCESS_RESET',
    TOURNAMENT_CASINO_UNREGISTER_FAIL: 'TOURNAMENT_CASINO_UNREGISTER_FAIL',
    GET_FINISHED_TOURID: 'GET_FINISHED_TOURID',
    TOGGLE_TOURNAMENTS: 'TOGGLE_TOURNAMENTS',
    TOURNAMENT_PLAYER_UPDATE: 'TOURNAMENT_PLAYER_UPDATE',
    TOURNAMENT_GAME_URL_REQUEST: 'TOURNAMENT_GAME_URL_REQUEST',
    TOURNAMENT_GAME_URL_REMOVE: 'TOURNAMENT_GAME_URL_REMOVE',
    TOURNAMENT_GAME_URL_FAIL: 'TOURNAMENT_GAME_URL_FAIL',
    TOURNAMENT_GAME_URL_SUCCESS: 'TOURNAMENT_GAME_URL_SUCCESS',
    TOURNAMENT_CHAT_UPDATE: 'TOURNAMENT_CHAT_UPDATE',
    OPEN_TOURNAMENT_CHAT: 'OPEN_TOURNAMENT_CHAT',
    CLOSE_TOURNAMENT_CHAT: 'CLOSE_TOURNAMENT_CHAT',

    GAME_URL_REQUEST: 'GAME_URL_REQUEST',
    GAME_URL_SUCCESS: 'GAME_URL_SUCCESS',
    GAME_URL_FAIL: 'GAME_URL_FAIL',
    GAME_URL_REMOVE: 'GAME_URL_REMOVE',

    REQUEST_CLUB_TABLES: "REQUEST_CLUB_TABLES",
    CLUB_TABLES_SUCCESS: "CLUB_TABLES_SUCCESS",
    RESET_CLUB_TABLES: "RESET_CLUB_TABLES",
    CLUB_TABLES_FAILURE: "CLUB_TABLES_FAILURE",

    CREATE_TABLE_REQUEST: "CREATE_TABLE_REQUEST",
    CREATE_TABLE_SUCCESS: "CREATE_TABLE_SUCCESS",

    CLUBS_INFO_REQUEST: "CLUBS_INFO_REQUEST",
    CLUBS_INFO_SUCCESS: "CLUBS_INFO_SUCCESS",
    RECEIVED_LEVEL_OPTIONS: "RECEIVED_LEVEL_OPTIONS",

    CLUB_DATA_REQUEST: 'CLUB_DATA_REQUEST',
    CLUB_DATA_SUCCESS: 'CLUB_DATA_SUCCESS',

    CREATE_UNION_REQUEST: 'CREATE_UNION_REQUEST',
    CREATE_UNION_SUCCESS: 'CREATE_UNION_SUCCESS',

    JOIN_UNION_REQUEST: 'JOIN_UNION_REQUEST',
    JOIN_UNION_SUCCESS: 'JOIN_UNION_SUCCESS',

    DISBAND_UNION_REQUEST: 'DISBAND_UNION_REQUEST',
    DISBAND_UNION_SUCCESS: 'DISBAND_UNION_SUCCESS',

    QUIT_UNION_CLUB_REQUEST: 'QUIT_UNION_CLUB_REQUEST',
    QUIT_UNION_CLUB_SUCCESS: 'QUIT_UNION_CLUB_SUCCESS',

    UNION_MEMBERS_REQUEST: 'UNION_MEMBERS_REQUEST',
    UNION_MEMBERS_SUCCESS: 'UNION_MEMBERS_SUCCESS',

    UNION_PENDINGS_REQUEST: 'UNION_PENDINGS_REQUEST',
    UNION_PENDINGS_SUCCESS: 'UNION_PENDINGS_SUCCESS',

    UNION_ACCEPT_DECLINE_CLUB_REQUEST: 'UNION_ACCEPT_DECLINE_CLUB_REQUEST',
    UNION_ACCEPT_DECLINE_CLUB_SUCCESS: 'UNION_ACCEPT_DECLINE_CLUB_SUCCESS',

    UNION_CHANGE_IMAGE: "UNION_CHANGE_IMAGE",

    CHANGE_MEMBER_STATUS_REQUEST: "CHANGE_MEMBER_STATUS_REQUEST",
    CHANGE_MEMBER_STATUS_SUCCESS: "CHANGE_MEMBER_STATUS_SUCCESS",

    CHANGE_MEMBER_ROLE_REQUEST: 'CHANGE_MEMBER_ROLE_REQUEST',
    CHANGE_MEMBER_ROLE_SUCCESS: 'CHANGE_MEMBER_ROLE_SUCCESS',
    CHANGE_MEMBER_ROLE_FAILURE: 'CHANGE_MEMBER_ROLE_FAILURE',

    AVATAR_MENU_REQUEST: "AVATAR_MENU_REQUEST",
    AVATAR_MENU_SUCCESS: "AVATAR_MENU_SUCCESS",

    GET_MEMBERS: "GET_MEMBERS",
    MEMBERS_SUCCESS: "MEMBERS_SUCCESS",
    MEMBERS_FAILURE: "MEMBERS_FAILURE",

    REMOVE_MEMBER_REQUEST: "REMOVE_MEMBER_REQUEST",
    REMOVE_MEMBER_SUCCESS: "REMOVE_MEMBER_SUCCESS",
    REMOVE_MEMBER_FAILURE: "REMOVE_MEMBER_FAILURE",

    UPDATE_LEVEL_REQUEST: "UPDATE_LEVEL_REQUEST",
    UPDATE_LEVEL_SUCCESS: "UPDATE_LEVEL_SUCCESS",

    PENDING_REQUEST: "PENDING_REQUEST",
    PENDING_SUCCESS: "PENDING_SUCCESS",
    PENDING_FAILURE: "PENDING_FAILURE",

    GET_PLAYER: "GET_PLAYER",
    PLAYER_SUCCESS: "PLAYER_SUCCESS",
    PLAYER_FAILURE: "PLAYER_FAILURE",
    ADD_DOWNLINE_SUCCESS: "ADD_DOWNLINE_SUCCESS",
    REMOVE_DOWNLINE_SUCCESS: "REMOVE_DOWNLINE_SUCCESS",

    OPEN_DIALOG: "OPEN_DIALOG",
    CLOSE_DIALOG: "CLOSE_DIALOG",
    HIDE_DIALOG: "HIDE_DIALOG",

    OPEN_TABLE: "OPEN_TABLE",
    CLOSE_TABLE: "CLOSE_TABLE",

    USER_LOGIN: "USER_LOGIN",
    LOGIN_REQUEST: "LOGIN_REQUEST",
    LOGIN_SUCCESS: "LOGIN_SUCCESS",
    LOGIN_FAILURE: "LOGIN_FAILURE",
    USER_LOGOUT: "USER_LOGOUT",
    CHECK_AUTHENTICATION: "CHECK_AUTHENTICATION",

    USER_REGISTER: "USER_REGISTER",
    REGISTER_REQUEST: "REGISTER_REQUEST",
    REGISTER_SUCCESS: "REGISTER_SUCCESS",
    REGISTER_FAILURE: "REGISTER_FAILURE",

    PASSWORD_RECOVERY_REQUEST: "PASSWORD_RECOVERY_REQUEST",
    PASSWORD_RECOVERY_SUCCESS: "PASSWORD_RECOVERY_SUCCESS",
    PASSWORD_RECOVERY_FAILURE: "PASSWORD_RECOVERY_FAILURE",

    CREATE_CLUB_REQUEST: "CREATE_CLUB_REQUEST",
    CREATE_CLUB_SUCCESS: "CREATE_CLUB_SUCCESS",
    CREATE_CLUB_FAILURE: "CREATE_CLUB_FAILURE",

    JOIN_CLUB_REQUEST: "JOIN_CLUB_REQUEST",
    JOIN_CLUB_SUCCESS: "JOIN_CLUB_SUCCESS",
    JOIN_CLUB_FAILURE: "JOIN_CLUB_FAILURE",

    DAILY_BONUS_REQUEST: "DAILY_BONUS_REQUEST",
    DAILY_BONUS_SUCCESS: "DAILY_BONUS_SUCCESS",

    CHANGE_CLUB_REQUEST: "CHANGE_CLUB_REQUEST",
    CHANGE_CLUB_SUCCESS: "CHANGE_CLUB_SUCCESS",
    CHANGE_CLUB_FAILURE: "CHANGE_CLUB_FAILURE",

    CLUB_COUNTER_SUCCESS: "CLUB_COUNTER_SUCCESS",
    CLUB_COUNTER_MOVEMENTS_SUCCESS: "CLUB_COUNTER_MOVEMENTS_SUCCESS",
    CLUB_COUNTER_FAILURE: "CLUB_COUNTER_FAILURE",

    CONFIGURE_SPORT: "CONFIGURE_SPORT",
    RECONFIGURE_SPORT: "RECONFIGURE_SPORT",
    CONFIGURE_SPORT_FAILURE: "CONFIGURE_SPORT_FAILURE",
    RECONFIGURE_SPORT_FAILURE: "RECONFIGURE_SPORT_FAILURE",

    PROFILE_DETAILS_SUCCESS: "PROFILE_DETAILS_SUCCESS",
    PROFILE_DETAILS_UPDATE_SUCCESS: "PROFILE_DETAILS_UPDATE_SUCCESS",
    PROFILE_DETAILS_FAILURE: "PROFILE_DETAILS_FAILURE",

    CHANGE_PASSWORD_REQUEST: "CHANGE_PASSWORD_REQUEST",
    CHANGE_PASSWORD_SUCCESS: "CHANGE_PASSWORD_SUCCESS",
    CHANGE_PASSWORD_FAILURE: "CHANGE_PASSWORD_FAILURE",
    CHANGE_PASSWORD_DEFAULT: "CHANGE_PASSWORD_DEFAULT",

    CLOSE_FORM: "CLOSE_FORM",

    CHANGE_EMAIL_SUCCESS: "CHANGE_EMAIL_SUCCESS",
    CHANGE_EMAIL_FAILURE: "CHANGE_EMAIL_FAILURE",
    CHANGE_EMAIL_DEFAULT: "CHANGE_EMAIL_DEFAULT",

    CAREER_DATA_REQUEST: "CAREER_DATA_REQUEST",
    CAREER_DATA_SUCCESS: "CAREER_DATA_SUCCESS",
    CAREER_DATA_FAILURE: "CAREER_DATA_FAILURE",

    TOGGLE_CAREER_MENU: "TOGGLE_CAREER_MENU",

    CHANGE_PROFILE_AVATAR: "CHANGE_PROFILE_AVATAR",
    GLOBAL_AVATAR_SUCCESS: "GLOBAL_AVATAR_SUCCESS",
    GLOBAL_AVATAR_FAILURE: "GLOBAL_AVATAR_FAILURE",

    SET_PROFILE_AVATAR_REQUEST: "SET_PROFILE_AVATAR_REQUEST",
    SET_PROFILE_AVATAR_SUCCESS: "SET_PROFILE_AVATAR_SUCCESS",
    SET_PROFILE_AVATAR_FAILURE: "SET_PROFILE_AVATAR_FAILURE",

    AVATARS_REQUEST: "AVATARS_REQUEST",
    AVATARS_SUCCESS: "AVATARS_SUCCESS",

    AVATAR_JSON_SUCCESS: "AVATAR_JSON_SUCCESS",
    AVATAR_JSON_FAILURE: "AVATAR_JSON_FAILURE",

    ACCOUNTS_AVATARS_SUCCESS: "ACCOUNTS_AVATARS_SUCCESS",

    GET_REPORT_SUCCESS: "GET_REPORT_SUCCESS",
    GET_REPORT_FAILURE: "GET_REPORT_FAILURE",

    EXCHANGE_SAPPHIRES_REQUEST: "EXCHANGE_SAPPHIRES_REQUEST",
    EXCHANGE_SAPPHIRES_SUCCESS: "EXCHANGE_SAPPHIRES_SUCCESS",

    BALANCE_TRANSFER_REQUEST: "BALANCE_TRANSFER_REQUEST",
    BALANCE_TRANSFER_SUCCESS: "BALANCE_TRANSFER_SUCCESS",

    CLUB_TRANSFERS_REQUEST: "CLUB_TRANSFERS_REQUEST",
    CLUB_TRANSFERS_SUCCESS: "CLUB_TRANSFERS_SUCCESS",

    REFRESH_ACCOUNTS_DATA_REQUEST: "REFRESH_ACCOUNTS_DATA_REQUEST",
    REFRESH_ACCOUNTS_DATA_SUCCESS: "REFRESH_ACCOUNTS_DATA_SUCCESS",
    ADD_ACCOUNTS_DATA: "ADD_ACCOUNTS_DATA",
    REMOVE_ACCOUNTS_DATA: "REMOVE_ACCOUNTS_DATA",
    REFRESH_ACCOUNTS_DATA_FAILURE: "REFRESH_ACCOUNTS_DATA_FAILURE",

    UPDATE_REMARK: "UPDATE_REMARK",
    FAILURE_REMARK: "FAILURE_REMARK",

    SOUND_TOGGLE: "SOUND_TOGGLE",

    SHOW_NOTIFICATION: "SHOW_NOTIFICATION",
    RESET_NOTIFICATION: "RESET_NOTIFICATION",

    READ_MESSAGE_REQUEST: "READ_MESSAGE_REQUEST",
    READ_MESSAGE_SUCCESS: "READ_MESSAGE_SUCCESS",
    SET_UNREAD_MESSAGES_COUNT: "SET_UNREAD_MESSAGES_COUNT",
    OPEN_MESSAGE: "OPEN_MESSAGE",
    CLOSE_MESSAGE: "CLOSE_MESSAGE",
    DELETE_MESSAGE_REQUEST: "DELETE_MESSAGE_REQUEST",
    DELETE_MESSAGE_SUCCESS: "DELETE_MESSAGE_SUCCESS",
    
    SET_OPENED_MESSAGE: 'SET_OPENED_MESSAGE',
    CLOSE_OPENED_MESSAGE: 'CLOSE_OPENED_MESSAGE',

    GET_MESSAGES_REQUEST: "GET_MESSAGES_REQUEST",
    GET_MESSAGES_SUCCESS: "GET_MESSAGES_SUCCESS",

    GET_UNREAD_MESSAGES_REQUEST: "GET_UNREAD_MESSAGES_REQUEST",
    GET_UNREAD_MESSAGES_SUCCESS: "GET_UNREAD_MESSAGES_SUCCESS",

    QUIT_MEMBER_CLUB_REQUEST: "QUIT_MEMBER_CLUB_REQUEST",
    QUIT_MEMBER_CLUB_SUCCESS: "QUIT_MEMBER_CLUB_SUCCESS",

    SEND_MESSAGE_REQUEST: "SEND_MESSAGE_REQUEST",
    SEND_MESSAGE_SUCCESS: "SEND_MESSAGE_SUCCESS",

    SET_CLUB_ADMIN_SUB_DIALOG: "SET_CLUB_ADMIN_SUB_DIALOG",
    SEND_NOTIFICATION_SUCCESS: "SEND_NOTIFICATION_SUCCESS",

    GET_UNIONS_SUCCESS: "GET_UNIONS_SUCCESS",
    GET_UNIONS_FAILURE: "GET_UNIONS_FAILURE",
    GET_UNION_CLUBS_LIST_SUCCESS: "GET_UNION_CLUBS_LIST_SUCCESS",
    GET_UNION_CLUBS_LIST_FAILURE: "GET_UNION_CLUBS_LIST_FAILURE",
    GET_UNION_PENDING_LIST_SUCCESS: "GET_UNION_PENDING_LIST_SUCCESS",
    GET_UNION_PENDING_LIST_FAILURE: "GET_UNION_PENDING_LIST_FAILURE",
    REMOVE_UNION_SUCCESS: "REMOVE_UNION_SUCCESS",
    REMOVE_UNION_FAILURE: "REMOVE_UNION_FAILURE",
    GET_UNION_DATA_SUCCESS: "GET_UNION_DATA_SUCCESS",
    GET_UNION_DATA_FAILURE: "GET_UNION_DATA_FAILURE",

    UNION_CHANGE_REQUEST: "UNION_CHANGE_REQUEST",
    UNION_CHANGE_SUCCESS: "UNION_CHANGE_SUCCESS",
    UNION_CHANGE_FAILURE: "UNION_CHANGE_FAILURE",

    REMOVED_PLAYER: "REMOVED_PLAYER",

    LEADERBOARD_REQUEST: "LEADERBOARD_REQUEST",
    LEADERBOARD_SUCCESS: "LEADERBOARD_SUCCESS",
    LEADERSHIP_SUCCESS: "LEADERSHIP_SUCCESS",
    LEADERBOARD_FAILURE: "LEADERBOARD_FAILURE",
    LANGUAGE_CHANGE: "LANGUAGE_CHANGE",
    ALTER_POKER_FRAME: "ALTER_POKER_FRAME",
    INIT_POKER_FRAME: "INIT_POKER_FRAME",

    LINK_EMAIL_VERIFICATION_REQUEST: "LINK_EMAIL_VERIFICATION_REQUEST",
    LINK_EMAIL_VERIFICATION_SUCCESS: "LINK_EMAIL_VERIFICATION_SUCCESS",
    LINK_EMAIL_VERIFICATION_FAILURE: "LINK_EMAIL_VERIFICATION_FAILURE",
    LINK_EMAIL_VERIFICATION_CODE_SUCCESS: "LINK_EMAIL_VERIFICATION_CODE_SUCCESS",

    CLUB_PRODUCTS_SUCCESS: "CLUB_PRODUCTS_SUCCESS",

    UPDATE_SELECTED_MEMBERS: "UPDATE_SELECTED_MEMBERS",
    UPDATE_SELECTED_MEMBERS_SUCCESS: "UPDATE_SELECTED_MEMBERS_SUCCESS",
    UPDATE_SELECTED_MEMBERS_FAILURE: "UPDATE_SELECTED_MEMBERS_FAILURE",

    AGENT_TRANSACTION_HISTORY_REQUEST: "AGENT_TRANSACTION_HISTORY_REQUEST",
    AGENT_TRANSACTION_HISTORY_SUCCESS: "AGENT_TRANSACTION_HISTORY_SUCCESS",
    AGENT_TRANSACTION_HISTORY_FAILURE: "AGENT_TRANSACTION_HISTORY_FAILURE",
    AGENT_TRANSACTION_REQUEST: "AGENT_TRANSACTION_REQUEST",

    AGENT_DETAILS_REQUEST: "AGENT_DETAILS_REQUEST",
    AGENT_DETAILS_SUCCESS: "AGENT_DETAILS_SUCCESS",
    AGENT_DETAILS_FAILURE: "AGENT_DETAILS_FAILURE",
    MEMBER_DETAILS_REQUEST: "MEMBER_DETAILS_REQUEST",
    MEMBER_DETAILS_SUCCESS: "MEMBER_DETAILS_SUCCESS",
    MEMBER_DETAILS_FAILURE: "MEMBER_DETAILS_FAILURE",

    EXPORT_DATA_REQUEST: "EXPORT_DATA_REQUEST",
    EXPORT_DATA_SUCCESS: "EXPORT_DATA_SUCCESS",
    EXPORT_DATA_FAILURE: "EXPORT_DATA_FAILURE",

    REFRESH_ACCOUNT_BALANCE_REQUEST: "REFRESH_ACCOUNT_BALANCE_REQUEST",
    REFRESH_ACCOUNT_BALANCE_SUCCESS: "REFRESH_ACCOUNT_BALANCE_SUCCESS",

    GAME_TRANSFERS_REQUEST: "GAME_TRANSFERS_REQUEST",
    GAME_TRANSFERS_SUCCESS: "GAME_TRANSFERS_SUCCESS",
    GAME_TRANSFERS_FAILURE: "GAME_TRANSFERS_FAILURE",
    LEAVE_CLUB: "LEAVE_CLUB",
};

export default actionTypes
